import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';

interface CustomPaymentErrorMessageProps {
    errorMessage?: string;
}

export const CustomPaymentErrorMessage: React.FC<CustomPaymentErrorMessageProps> = ({ errorMessage }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', paddingTop: '2rem' }}>
            <Panel
                theme={PanelTheme.Red}
                borderRadius={PanelBorderRadius.Small}
                borderStyle={PanelBorderStyle.None}
                width={'100%'}
            >
                {errorMessage}
            </Panel>
        </div>
    );
};
